import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

export function ProjectTypesRedirect() {
	const { configurationId } = useParams<{ configurationId: string }>();
	if (configurationId) {
		return (
			<Navigate
				to={`/project-configuration/types/${configurationId}`}
				replace
			/>
		);
	}
	return <Navigate to="/project-configuration/types" replace />;
}

export function ProjectSubTypesRedirect() {
	const { projectSubTypeId } = useParams<{ projectSubTypeId: string }>();
	if (projectSubTypeId) {
		return (
			<Navigate
				to={`/project-configuration/sub-types/${projectSubTypeId}`}
				replace
			/>
		);
	}
	return <Navigate to="/project-configuration/sub-types" replace />;
}

export function ProjectSettingsRedirect() {
	const { configurationId } = useParams<{ configurationId: string }>();
	if (configurationId) {
		return (
			<Navigate
				to={`/project-configuration/data/${configurationId}`}
				replace
			/>
		);
	}
	return <Navigate to="/project-configuration/data" replace />;
}

